import Angle2DParser from "../Util/Angle2DParser";
function Angle2DConverter(val) {
    if (typeof val === "number") {
        return val;
    }
    if (typeof val === "string") {
        return Angle2DParser.parseAngle(val);
    }
}
export default Angle2DConverter;



// WEBPACK FOOTER //
// ./src/Converters/Angle2DConverter.ts